module.exports = __webpack_public_path__ + "static/media/6--mobile.4304fbf4.webp";